import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Real Cafe ( Hensi ). All rights reserved.</p>
    </footer>
  );
};

export default Footer;
